import React from 'react';
import 'twin.macro';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@teetsh/app/src/components/Resizable';
import { Sidebar } from '@teetsh/app/src/containers/RegistreAppel/Preview/Stats/Sidebar';
import { Body } from '@teetsh/app/src/containers/RegistreAppel/Preview/Stats/Body';
import { Form } from 'react-final-form';
import { AppelsStatsPDFSettings } from '@teetsh/app/src/containers/RegistreAppel/Print/types';
import AutoSubmitForm from '@teetsh/app/src/components/AutoSave';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import startOfMonth from '@teetsh/app/src/utils/time/startOfMonth';
import endOfMonth from '@teetsh/app/src/utils/time/endOfMonth';

export function AppelsStatsPreview() {
  const user = useUser();
  const updateUser = useUpdateUser();
  const { data: userAccount } = useUserAccount();

  const params = useParams<{
    schoolyearId: string;
    schoolId: string;
    eleveId: string;
  }>();
  const eleveId = params.eleveId as string;

  const [qsParams] = useSearchParams();
  const from = qsParams.get('from')
    ? new Date(qsParams.get('from')!)
    : startOfMonth(new Date());
  const to = qsParams.get('to')
    ? new Date(qsParams.get('to')!)
    : endOfMonth(new Date());

  return (
    <Form<AppelsStatsPDFSettings>
      initialValues={user.fonts.appelsStats}
      onSubmit={async values => {
        await updateUser({
          ...user,
          fonts: {
            ...user.fonts,
            appelsStats: values,
          },
        });
        return {};
      }}
    >
      {({ handleSubmit }) => (
        <form tw="min-h-0 h-full" onSubmit={handleSubmit}>
          <AutoSubmitForm />
          <div tw="w-full h-full flex flex-col overflow-hidden">
            <ResizablePanelGroup
              direction="horizontal"
              autoSaveId="appels-stats-preview-sidebar"
            >
              <Sidebar
                from={from}
                to={to}
                eleveId={eleveId}
                lng={user.locale}
                tz={user.location}
                limitedBgSet={userAccount?.isOnOldPricing || false}
              />
              <ResizableHandle />
              <ResizablePanel order={1}>
                <div tw="h-full overflow-auto">
                  <Body
                    schoolyearId={params.schoolyearId as string}
                    schoolId={params.schoolId as string}
                    from={from}
                    to={to}
                    eleveId={eleveId}
                    lng={user.locale}
                    tz={user.location}
                  />
                </div>
              </ResizablePanel>
            </ResizablePanelGroup>
          </div>
        </form>
      )}
    </Form>
  );
}
